module.exports = __webpack_public_path__ + "img/tutorial-13.5b7c3470.svg";